import type { ReactNode } from 'react';

import React from 'react';
import { Empty, Typography } from 'antd';

const { Title } = Typography;

const illustrationUrl = new URL(
  './images/undraw_Selection_re_poer.svg',
  import.meta.url,
).toString();

type EmptyStateProps = {
  description: ReactNode;
};

export const EmptyState = ({ description }: EmptyStateProps) => (
  <Empty
    image={illustrationUrl}
    description={<Title level={4}>{description}</Title>}
    styles={{ image: { height: 200 } }}
  />
);
